import React, { useEffect, useRef, useState } from "react";
import {
  InputCheck,
  InputCheckNo,
  InputCheckNone,
  InputCheckYes,
  InputSingleCheck,
  NuFormInput,
  NuFormInputNumber,
  NuFormSelect,
  NuFormTextArea,
  NuInput,
  NuInputfile,
  NuRowFormInput,
  NuTableFormInput,
  NuTableFormSelect,
  NuTableFormTextArea,
} from "./Input";
import { CancelButton, SubmitButton } from "./Buttons";
import SignatureCanvas from "react-signature-canvas";
import Attachement from "./CustomAttrachmentupload";
import { useToast } from "../Others/ToastServices";
import useFetchMataData from "../Hooks/useFetchMataData";
import FilesView from "./FilesView";

function NewCommonDynamicForm({
  formData,
  formik,
  expandedIndex,
  index,
  allValue,
  setAllValue,
  SaveFormData,
  editModeIndex = true,
  hasSign = true,
  hasSignOne = true,
  hasSignTwo = true,
  hasSignThree = false,
  hasSignFour = false,
  hasSignFive = false,
  SignOne = "Collector Signature",
  SignTwo = "Client Signature",
  SignThree = "Collector Signature",
  SignFour = "Client Signature",
  SignFive = "Client Signature",
  setSignFunOne = () => {},
  setSignFunTwo = () => {},
  setSignFunThree = () => {},
  setSignFunFour = () => {},
  setSignFunFive = () => {},
  selectedFile = [],
  setSelectedFile = () => {},
  FileAttachment = () => {},
  allData = [],
  setFileRemoveList = () => {},
  fileRemoveList = [],
  setRemoveSignOne = () => {},
  setRemoveSignTwo = () => {},
  setRemoveSignThree = () => {},
  setRemoveSignFour = () => {},
  setRemoveSignFive = () => {},
}) {
  const { value: unit, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );

  function giveValue(value, formik) {
    switch (value?.field_type) {
      case "text":
        return (
          <>
            <div className={`w-full py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label || "  "}</p>
                  </td>
                  <td className="w-2/5">
                    <NuFormInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      id={value?.id}
                      field_type={value?.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex === false}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "number":
        return (
          <>
            <div className={`w-full py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5 text-right">
                    <p>{value?.field_label || "  "}</p>
                  </td>
                  <td className="w-2/5">
                    <NuFormInputNumber
                      label={""}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      id={value?.id}
                      field_type={value?.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex === false}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "string":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs  mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.Name}</p>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "yesno":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"Yes" || ""}</p>
                      <InputCheckYes
                        type={"checkbox"}
                        formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex === false}
                        label={value?.field_label}
                      />
                    </div>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"No" || ""}</p>
                      <InputCheckNo
                        type={"checkbox"}
                        formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex === false}
                        label={value?.field_label}
                      />
                    </div>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"N/A" || ""}</p>
                      <InputCheckNone
                        type={"checkbox"}
                        formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex === false}
                        label={value?.field_label}
                      />
                    </div>
                  </td>
                  {/* {[
                    { label: "Yes", type: "checkbox" },
                    { label: "No", type: "checkbox" },
                    { label: "N/A", type: "checkbox" },
                  ] &&
                    [
                      { label: "Yes", type: "checkbox" },
                      { label: "No", type: "checkbox" },
                      { label: "N/A", type: "checkbox" },
                    ].map((item, k) => {
                      return (
                        <td key={k}>
                          <div className="flex justify-center items-center gap-2">
                            <p>{item?.label || ""}</p>
                            <InputCheck
                              type={item?.type}
                              formik={formik}
                              placeholder={""}
                              name={item?.label}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={allValue}
                              setAllValue={setAllValue}
                              disabled={editModeIndex === false}
                            />
                          </div>
                        </td>
                      );
                    })} */}
                </tr>
              </table>
            </div>
          </>
        );
      case "checkbox":
        return (
          <>
            <div className="w-full py-2 text-xs mt-5">
              <table className="w-full">
                <tbody>
                  <tr>
                    <td className="w-2/12 align-top">
                      <p>{value?.field_label}</p>
                    </td>

                    <td className="w-10/12 p-0">
                      <table className="w-full">
                        <tbody>
                          {Array.from({
                            length: Math.ceil(
                              Object.entries(value?.metadata).length / 5
                            ),
                          }).map((_, rowIndex) => {
                            const items = Object.entries(value?.metadata).slice(
                              rowIndex * 5,
                              rowIndex * 5 + 5
                            );
                            const emptyCells = 5 - items.length;

                            return (
                              <tr key={rowIndex}>
                                {Array.from({ length: emptyCells }).map(
                                  (_, i) => (
                                    <td
                                      key={`empty-${i}`}
                                      className="w-1/6 p-2"
                                    ></td>
                                  )
                                )}

                                {items.map(([key, valueOf], idx) => (
                                  <td key={idx} className="w-1/6 p-2">
                                    <div className="flex flex-row-reverse justify-start items-center gap-2">
                                      <InputCheck
                                        fullValue={value?.value}
                                        label={key}
                                        formik={formik}
                                        placeholder=""
                                        name={key}
                                        id={value?.id}
                                        field_type={value?.field_type}
                                        allValue={allValue}
                                        setAllValue={setAllValue}
                                        disabled={editModeIndex === false}
                                      />
                                      <p>{key}</p>
                                    </div>
                                  </td>
                                ))}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        );
      case "single_checkbox":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-2/12">
                    <p>{value?.field_label}</p>
                  </td>
                  {value?.metadata &&
                    Object.entries(value?.metadata).map(
                      ([key, valueOf], idxOne) => (
                        <td key={idxOne} className=" w-1/12 p-2 ">
                          <div className="flex flex-row-reverse justify-start items-center gap-2">
                            <InputSingleCheck
                              fullValue={value?.value}
                              label={key}
                              formik={formik}
                              placeholder={""}
                              name={key}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={allValue}
                              setAllValue={setAllValue}
                              disabled={editModeIndex === false}
                            />
                            <p>{key || ""}</p>
                          </div>
                        </td>
                      )
                    )}
                </tr>
              </table>
            </div>
          </>
        );
      case "textArea":
        return (
          <>
            <NuFormTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
              id={value?.id}
              field_type={value?.field_type}
              allValue={allValue}
              setAllValue={setAllValue}
              disabled={editModeIndex === false}
            />
          </>
        );
      case "observation":
        return (
          <>
            <NuFormTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
              id={value?.id}
              field_type={value?.field_type}
              allValue={allValue}
              setAllValue={setAllValue}
              disabled={editModeIndex === false}
            />
          </>
        );
      case "date":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs w-full  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  <td className="w-2/5">
                    <NuFormInput
                      label={""}
                      type={"date"}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      id={value?.id}
                      field_type={value?.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex === false}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "time":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.Name}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      disabled={editModeIndex === false}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "imagePath":
        return (
          <>
            <NuInputfile
              label={""}
              name={value?.field_label}
              handleChange={() => {}}
              width={"w-full"}
              placeholder="file upload"
            />
          </>
        );
      case "file":
        return (
          <>
            <NuInputfile
              label={""}
              name={value?.field_label}
              handleChange={() => {}}
              width={"w-full"}
              placeholder="file upload"
            />
          </>
        );
      case "table-data":
        return (
          <>
            <div className=" w-full">
              <table className=" w-full  text-xs">
                <thead>
                  <tr>
                    {value?.value &&
                      value?.value.map((item, k) => {
                        return (
                          <th key={k} className="text-left py-2 px-4 ">
                            {item?.label || ""}
                          </th>
                        );
                      })}
                  </tr>
                </thead>
                <tbody>
                  {Array(10)
                    .fill(0)
                    .map((_, i) => (
                      <tr key={i}>
                        {value?.value &&
                          value?.value.map((item, k) => {
                            return (
                              <td
                                key={k}
                                className="text-left py-2 px-4  h-8 border"
                              >
                                {""}
                              </td>
                            );
                          })}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        );
      case "multi":
        return (
          <>
            <div className=" w-full">
              {value?.metadata && Object.keys(value?.metadata).length > 3 ? (
                <div className="grid grid-cols-4 gap-2 items-center text-xs  ">
                  <div>{value?.field_label || ""}</div>
                  {Object.entries(value?.metadata).map(([key, valueOf], i) => {
                    return (
                      <>
                        {key == "Comments" ? (
                          <div
                            className=" col-span-3 grid grid-cols-3  "
                            key={i}
                          >
                            <div></div>
                            <div className=" col-span-2 flex items-center justify-end ">
                              <p className="  ">{key || ""}</p>
                              <NuFormTextArea
                                placeholder={""}
                                formik={formik}
                                name={valueOf?.value}
                                new_width={"w-5/6"}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex === false}
                                label={key}
                              />
                            </div>
                          </div>
                        ) : (
                          <>
                            {valueOf == "text" ? (
                              <div
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " w-full"
                                    : " w-full"
                                } flex gap-3 items-center ${
                                  (i + 1) % 5 !== 1 ? "text-end" : "text-start "
                                } ${i + 1 === 1 ? "text-end" : ""}  ${
                                  (i + 1) % 4 === 0 && i + 1 !== 1
                                    ? " col-span-2 "
                                    : ""
                                }`}
                                key={i}
                              >
                                {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                  <>
                                    <div className=" w-full flex justify-end items-center gap-2">
                                      <div className=" w-1/2"></div>
                                      <div className=" w-1/2 flex gap-1 items-center">
                                        <p className=" w-1/3 text-xs mr-1.5">
                                          {key || ""}
                                        </p>
                                        <NuFormInput
                                          label={key}
                                          type={valueOf?.type}
                                          formik={formik}
                                          placeholder={valueOf?.Name}
                                          name={valueOf?.value}
                                          id={value?.id}
                                          field_type={value?.field_type}
                                          allValue={allValue}
                                          setAllValue={setAllValue}
                                          width={" w-2/3 "}
                                          disabled={editModeIndex === false}
                                        />
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p className=" w-1/3 text-xs text-right ">
                                      {key || ""}
                                    </p>
                                    <NuFormInput
                                      label={key}
                                      type={valueOf?.type}
                                      formik={formik}
                                      placeholder={valueOf?.Name}
                                      name={valueOf?.value}
                                      id={value?.id}
                                      field_type={value?.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      width={" w-2/3 "}
                                      disabled={editModeIndex === false}
                                    />
                                  </>
                                )}
                              </div>
                            ) : valueOf == "string" ? (
                              <div className=" w-full text-xs ">
                                <p className=" w-full">{key || ""}</p>
                              </div>
                            ) : valueOf == "yesno" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-3/5 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      <td className="px-2">
                                        <div className="flex justify-center items-center gap-1.5">
                                          <p>{"Yes" || ""}</p>
                                          <InputCheckYes
                                            type={"checkbox"}
                                            formik={formik}
                                            placeholder={""}
                                            name={value?.field_label}
                                            id={value?.id}
                                            field_type={value?.field_type}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            disabled={editModeIndex === false}
                                            label={value?.field_label}
                                          />
                                        </div>
                                      </td>
                                      <td className="px-2">
                                        <div className="flex justify-center items-center gap-1.5">
                                          <p>{"No" || ""}</p>
                                          <InputCheckNo
                                            type={"checkbox"}
                                            formik={formik}
                                            placeholder={""}
                                            name={value?.field_label}
                                            id={value?.id}
                                            field_type={value?.field_type}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            disabled={editModeIndex === false}
                                            label={value?.field_label}
                                          />
                                        </div>
                                      </td>
                                      <td className="px-2">
                                        <div className="flex justify-center items-center gap-1.5">
                                          <p>{"N/A" || ""}</p>
                                          <InputCheckNone
                                            type={"checkbox"}
                                            formik={formik}
                                            placeholder={""}
                                            name={value?.field_label}
                                            id={value?.id}
                                            field_type={value?.field_type}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            disabled={editModeIndex === false}
                                            label={value?.field_label}
                                          />
                                        </div>
                                      </td>
                                      {/* {[
                                      { label: "Yes", type: "checkbox" },
                                      { label: "No", type: "checkbox" },
                                      { label: "N/A", type: "checkbox" },
                                    ] &&
                                      [
                                        { label: "Yes", type: "checkbox" },
                                        { label: "No", type: "checkbox" },
                                        { label: "N/A", type: "checkbox" },
                                      ].map((item, k) => {
                                        return (

                                        );
                                      })} */}
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : valueOf == "number" ? (
                              <>
                                <div
                                  className={`${
                                    Object.keys(value?.metadata).length >= 3
                                      ? " w-full"
                                      : " w-full"
                                  } flex gap-3 items-center ${
                                    (i + 1) % 5 !== 1
                                      ? "text-end"
                                      : "text-start "
                                  } ${i + 1 === 1 ? "text-end" : ""}  ${
                                    (i + 1) % 4 === 0 && i + 1 !== 1
                                      ? " col-span-2 "
                                      : ""
                                  }`}
                                >
                                  {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                    <>
                                      <div className=" w-full flex justify-end items-center gap-2">
                                        <div className=" w-1/2"></div>
                                        <div className=" w-1/2 flex gap-1 items-center">
                                          <p className=" w-1/3 text-xs">
                                            {key || ""}
                                          </p>
                                          <NuFormInputNumber
                                            label={key}
                                            type={valueOf?.type}
                                            formik={formik}
                                            placeholder={valueOf?.Name}
                                            name={valueOf?.value}
                                            id={value?.id}
                                            field_type={value?.field_type}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            width={" w-2/3 "}
                                            disabled={editModeIndex === false}
                                          />
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <p className=" w-1/3 text-xs text-right">
                                        {key || ""}
                                      </p>
                                      <NuFormInputNumber
                                        label={key}
                                        type={valueOf?.type}
                                        formik={formik}
                                        placeholder={valueOf?.Name}
                                        name={valueOf?.value}
                                        id={value?.id}
                                        field_type={value?.field_type}
                                        allValue={allValue}
                                        setAllValue={setAllValue}
                                        width={" w-2/3 "}
                                        disabled={editModeIndex === false}
                                      />
                                    </>
                                  )}
                                </div>
                              </>
                            ) : valueOf == "checkbox" ? (
                              <>
                                <div
                                  className={`${
                                    Object.keys(value?.metadata).length >= 3
                                      ? " w-full"
                                      : " w-full"
                                  } flex gap-3 items-center ${
                                    (i + 1) % 5 !== 1
                                      ? "text-end"
                                      : "text-start "
                                  } ${i + 1 === 1 ? "text-end" : ""}  ${
                                    (i + 1) % 4 === 0 && i + 1 !== 1
                                      ? " col-span-2 "
                                      : ""
                                  }`}
                                >
                                  {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                    <>
                                      <div className=" w-full flex justify-end items-center gap-2">
                                        <div className=" w-1/2"></div>
                                        <div className=" w-1/2 flex gap-1 items-center">
                                          <p className=" w-1/3 text-xs">
                                            {key || ""}
                                          </p>
                                          <InputCheck
                                            type={"checkbox"}
                                            formik={formik}
                                            placeholder={""}
                                            name={key}
                                            id={value?.id}
                                            field_type={valueOf}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            disabled={editModeIndex === false}
                                            label={key}
                                          />
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <p className=" w-1/3 text-xs">
                                        {key || ""}
                                      </p>
                                      <InputCheck
                                        type={"checkbox"}
                                        formik={formik}
                                        placeholder={""}
                                        name={key}
                                        id={value?.id}
                                        field_type={valueOf}
                                        allValue={allValue}
                                        setAllValue={setAllValue}
                                        disabled={editModeIndex === false}
                                        label={key}
                                      />
                                    </>
                                  )}
                                </div>
                              </>
                            ) : valueOf == "truefalse" ? (
                              <>
                                <div className=" w-full flex justify-end items-center gap-2">
                                  <p className=" w-1/3  text-xs text-right">
                                    {key || ""}
                                  </p>
                                  <InputCheck
                                    type={"checkbox"}
                                    formik={formik}
                                    placeholder={""}
                                    name={key}
                                    id={value?.id}
                                    field_type={valueOf}
                                    allValue={allValue}
                                    setAllValue={setAllValue}
                                    disabled={editModeIndex === false}
                                    label={key}
                                  />
                                </div>
                              </>
                            ) : valueOf == "yesnona" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-3/5 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      <td className="px-2">
                                        <div className="flex justify-center items-center gap-1.5">
                                          <p>{"Yes" || ""}</p>
                                          <InputCheckYes
                                            type={"checkbox"}
                                            formik={formik}
                                            placeholder={""}
                                            name={value?.field_label}
                                            id={value?.id}
                                            field_type={value?.field_type}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            disabled={editModeIndex === false}
                                            label={value?.field_label}
                                          />
                                        </div>
                                      </td>
                                      <td className="px-2">
                                        <div className="flex justify-center items-center gap-1.5">
                                          <p>{"No" || ""}</p>
                                          <InputCheckNo
                                            type={"checkbox"}
                                            formik={formik}
                                            placeholder={""}
                                            name={value?.field_label}
                                            id={value?.id}
                                            field_type={value?.field_type}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            disabled={editModeIndex === false}
                                            label={value?.field_label}
                                          />
                                        </div>
                                      </td>
                                      <td className="px-2">
                                        <div className="flex justify-center items-center gap-1.5">
                                          <p>{"N/A" || ""}</p>
                                          <InputCheckNone
                                            type={"checkbox"}
                                            formik={formik}
                                            placeholder={""}
                                            name={value?.field_label}
                                            id={value?.id}
                                            field_type={value?.field_type}
                                            allValue={allValue}
                                            setAllValue={setAllValue}
                                            disabled={editModeIndex === false}
                                            label={value?.field_label}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : valueOf == "dropdown" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-5/12 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      <td className="px-2">
                                        <NuFormSelect
                                          name={key}
                                          label={key}
                                          placeholder={""}
                                          id={value?.id}
                                          field_type={value?.field_type}
                                          allValue={allValue}
                                          setAllValue={setAllValue}
                                          disabled={editModeIndex === false}
                                          options={unit || []}
                                        />
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : (
                              <div className="w-full text-xs ">
                                <p className="">{key || ""}</p>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
              ) : (
                <>
                  <table className="w-full  ">
                    <tr>
                      {value?.metadata &&
                        Object.entries(value?.metadata).map(
                          ([key, valueOf], idxTwo) => (
                            <>
                              <td
                                key={idxTwo}
                                className=" text-xs  text-end first:text-start"
                              >
                                {valueOf == "text" ? (
                                  <div
                                    className={`w-full flex gap-3 items-center `}
                                  >
                                    <p className=" w-1/2 text-xs">
                                      {key || ""}
                                    </p>
                                    <NuFormInput
                                      label={key}
                                      type={valueOf?.type}
                                      formik={formik}
                                      placeholder={valueOf?.Name}
                                      name={valueOf?.value}
                                      id={value?.id}
                                      field_type={value?.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      width={" w-1/2 "}
                                      disabled={editModeIndex === false}
                                    />
                                  </div>
                                ) : valueOf == "number" ? (
                                  <div
                                    className={`w-full flex gap-3 items-center `}
                                  >
                                    <p className=" w-1/2 text-xs">
                                      {key || ""}
                                    </p>
                                    <NuFormInput
                                      label={key}
                                      type={valueOf?.type}
                                      formik={formik}
                                      placeholder={valueOf?.Name}
                                      name={valueOf?.value}
                                      id={value?.id}
                                      field_type={value?.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      width={" w-1/2 "}
                                      disabled={editModeIndex === false}
                                    />
                                  </div>
                                ) : valueOf == "string" ? (
                                  <>
                                    <p>{key || ""}</p>
                                  </>
                                ) : valueOf == "yesnona" ? (
                                  <>
                                    <div className={`w-full py-2 text-xs  `}>
                                      <table className="w-full">
                                        <tr>
                                          <td className="w-3/5 text-end px-2">
                                            <p>{key}</p>
                                          </td>
                                          <td className="px-2">
                                            <div className="flex justify-center items-center gap-1.5">
                                              <p>{"Yes" || ""}</p>
                                              <InputCheckYes
                                                type={"checkbox"}
                                                formik={formik}
                                                placeholder={""}
                                                name={value?.field_label}
                                                id={value?.id}
                                                field_type={value?.field_type}
                                                allValue={allValue}
                                                setAllValue={setAllValue}
                                                disabled={
                                                  editModeIndex === false
                                                }
                                                label={value?.field_label}
                                              />
                                            </div>
                                          </td>
                                          <td className="px-2">
                                            <div className="flex justify-center items-center gap-1.5">
                                              <p>{"No" || ""}</p>
                                              <InputCheckNo
                                                type={"checkbox"}
                                                formik={formik}
                                                placeholder={""}
                                                name={value?.field_label}
                                                id={value?.id}
                                                field_type={value?.field_type}
                                                allValue={allValue}
                                                setAllValue={setAllValue}
                                                disabled={
                                                  editModeIndex === false
                                                }
                                                label={value?.field_label}
                                              />
                                            </div>
                                          </td>
                                          <td className="px-2">
                                            <div className="flex justify-center items-center gap-1.5">
                                              <p>{"N/A" || ""}</p>
                                              <InputCheckNone
                                                type={"checkbox"}
                                                formik={formik}
                                                placeholder={""}
                                                name={value?.field_label}
                                                id={value?.id}
                                                field_type={value?.field_type}
                                                allValue={allValue}
                                                setAllValue={setAllValue}
                                                disabled={
                                                  editModeIndex === false
                                                }
                                                label={value?.field_label}
                                              />
                                            </div>
                                          </td>
                                          {/* {[
                                      { label: "Yes", type: "checkbox" },
                                      { label: "No", type: "checkbox" },
                                      { label: "N/A", type: "checkbox" },
                                    ] &&
                                      [
                                        { label: "Yes", type: "checkbox" },
                                        { label: "No", type: "checkbox" },
                                        { label: "N/A", type: "checkbox" },
                                      ].map((item, k) => {
                                        return (

                                        );
                                      })} */}
                                        </tr>
                                      </table>
                                    </div>
                                  </>
                                ) : valueOf == "yesno" ? (
                                  <>
                                    <div className={`w-full py-2 text-xs  `}>
                                      <table className="w-full">
                                        <tr>
                                          <td className="w-3/5 text-end px-2">
                                            <p>{key}</p>
                                          </td>
                                          <td className="px-2">
                                            <div className="flex justify-center items-center gap-1.5">
                                              <p>{"Yes" || ""}</p>
                                              <InputCheckYes
                                                type={"checkbox"}
                                                formik={formik}
                                                placeholder={""}
                                                name={value?.field_label}
                                                id={value?.id}
                                                field_type={value?.field_type}
                                                allValue={allValue}
                                                setAllValue={setAllValue}
                                                disabled={
                                                  editModeIndex === false
                                                }
                                                label={key}
                                              />
                                            </div>
                                          </td>
                                          <td className="px-2">
                                            <div className="flex justify-center items-center gap-1.5">
                                              <p>{"No" || ""}</p>
                                              <InputCheckNo
                                                type={"checkbox"}
                                                formik={formik}
                                                placeholder={""}
                                                name={value?.field_label}
                                                id={value?.id}
                                                field_type={value?.field_type}
                                                allValue={allValue}
                                                setAllValue={setAllValue}
                                                disabled={
                                                  editModeIndex === false
                                                }
                                                label={key}
                                              />
                                            </div>
                                          </td>
                                          <td className="px-2">
                                            <div className="flex justify-center items-center gap-1.5">
                                              <p>{"N/A" || ""}</p>
                                              <InputCheckNone
                                                type={"checkbox"}
                                                formik={formik}
                                                placeholder={""}
                                                name={value?.field_label}
                                                id={value?.id}
                                                field_type={value?.field_type}
                                                allValue={allValue}
                                                setAllValue={setAllValue}
                                                disabled={
                                                  editModeIndex === false
                                                }
                                                label={key}
                                              />
                                            </div>
                                          </td>
                                          {/* {[
                                      { label: "Yes", type: "checkbox" },
                                      { label: "No", type: "checkbox" },
                                      { label: "N/A", type: "checkbox" },
                                    ] &&
                                      [
                                        { label: "Yes", type: "checkbox" },
                                        { label: "No", type: "checkbox" },
                                        { label: "N/A", type: "checkbox" },
                                      ].map((item, k) => {
                                        return (

                                        );
                                      })} */}
                                        </tr>
                                      </table>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p>{`${key} ${valueOf}` || ""}</p>
                                  </>
                                )}
                              </td>
                            </>
                          )
                        )}
                    </tr>
                  </table>
                </>
              )}
            </div>
          </>
        );
      case "tableRow":
        return (
          <>
            <table className="w-full border border-collapse">
              <tr>
                {/* <td className="w-2/12 text-xs border px-2">
                  <p>{value?.field_label}</p>
                </td> */}
                {
                  <>
                    {Object.entries(value?.metadata).map(
                      ([key, valueOf], idxThree) => {
                        return (
                          <>
                            {valueOf == "text" ? (
                              <td
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " "
                                    : "   "
                                }text-xs border-y px-3`}
                                key={idxThree}
                              >
                                {/* <p className=" w-1/2">{key || ""}</p> */}
                                <NuRowFormInput
                                  label={key}
                                  type={"text"}
                                  formik={formik}
                                  placeholder={valueOf?.Name}
                                  name={valueOf?.value}
                                  id={value?.id}
                                  field_type={value?.field_type}
                                  allValue={allValue}
                                  setAllValue={setAllValue}
                                  width={"w-full "}
                                  disabled={editModeIndex === false}
                                />
                              </td>
                            ) : valueOf == "date" ? (
                              <td
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " "
                                    : "   "
                                }text-xs border px-3`}
                              >
                                {/* <p className=" w-1/2">{key || ""}</p> */}
                                <NuRowFormInput
                                  label={key}
                                  type={"date"}
                                  formik={formik}
                                  placeholder={valueOf?.Name}
                                  name={valueOf?.value}
                                  id={value?.id}
                                  field_type={value?.field_type}
                                  allValue={allValue}
                                  setAllValue={setAllValue}
                                  width={"w-full "}
                                  disabled={editModeIndex === false}
                                />
                              </td>
                            ) : value == "string" ? (
                              <td className=" w-full">
                                <p className=" w-full">{key || ""}</p>
                              </td>
                            ) : (
                              <td className="w-full">
                                <p className="">{`${key} testt ` || ""}</p>
                              </td>
                            )}
                          </>
                        );
                      }
                    )}
                  </>
                }
              </tr>
            </table>
          </>
        );
      case "tableItems":
        return (
          <>
            {value?.field_label == "items" ? (
              <div className=" w-full">
                {Array.isArray(value?.metadata) &&
                value?.metadata.length > 0 ? (
                  <>
                    {value?.metadata.map((item, indx) => (
                      <div
                        key={indx}
                        className=" w-full text-xs grid grid-cols-3 2xl:grid-cols-4  gap-4 items-center border-b py-3"
                      >
                        {Object.entries(item).map(([key, valueOf], idx) => (
                          <div
                            key={idx}
                            className={`${
                              valueOf == "textArea" ? "col-span-2" : ""
                            } flex gap-2 items-center`}
                          >
                            <p
                              className={`${
                                valueOf == "textArea" ? "w-2/12" : " w-2/5"
                              }`}
                            >
                              {`${key} :` || ""}
                            </p>
                            <p>:</p>
                            <div
                              className={`${
                                valueOf == "textArea"
                                  ? "w-10/12 pl-5"
                                  : " w-3/5"
                              }`}
                            >
                              {valueOf == "text" ? (
                                <>
                                  <NuTableFormInput
                                    label={key}
                                    type={"text"}
                                    formik={formik}
                                    placeholder={value?.Name}
                                    name={`${key}${valueOf}${indx}`}
                                    width={"w-full"}
                                    id={value?.id}
                                    field_type={value?.field_type}
                                    allValue={allValue}
                                    setAllValue={setAllValue}
                                    disabled={editModeIndex === false}
                                    idx={indx + 1}
                                  />
                                </>
                              ) : valueOf == "number" ? (
                                <>
                                  <NuTableFormInput
                                    label={key}
                                    type={"text"}
                                    formik={formik}
                                    placeholder={value?.Name}
                                    name={`${key}${valueOf}${indx}`}
                                    width={"w-full"}
                                    id={value?.id}
                                    field_type={value?.field_type}
                                    allValue={allValue}
                                    setAllValue={setAllValue}
                                    disabled={editModeIndex === false}
                                    idx={indx + 1}
                                  />
                                </>
                              ) : valueOf == "legends" ? (
                                <>
                                  <NuTableFormSelect
                                    label={key}
                                    type={"text"}
                                    formik={formik}
                                    placeholder={value?.Name}
                                    name={`${key}${valueOf}${indx}`}
                                    width={"w-full"}
                                    id={value?.id}
                                    field_type={value?.field_type}
                                    allValue={allValue}
                                    setAllValue={setAllValue}
                                    disabled={editModeIndex === false}
                                    idx={indx + 1}
                                    options={[
                                      {
                                        label: "Good",
                                        value: "Good",
                                      },
                                      {
                                        label: "Defective",
                                        value: "Defective",
                                      },
                                      {
                                        label: "Missing",
                                        value: "Missing",
                                      },
                                      {
                                        label: "N/A",
                                        value: "N/A",
                                      },
                                    ]}
                                  />
                                </>
                              ) : valueOf == "textArea"?(
                                <>
                                  <NuTableFormTextArea
                                    label={key}
                                    formik={formik}
                                    placeholder={value?.Name}
                                    name={`${key}${valueOf}${indx}`}
                                    width={"w-full"}
                                    id={value?.id}
                                    field_type={value?.field_type}
                                    allValue={allValue}
                                    setAllValue={setAllValue}
                                    disabled={editModeIndex === false}
                                    idx={indx + 1}
                                  />
                                </>
                              ) : (
                                <>
                                  <p>{key || ""}</p>
                                </>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </>
                ) : (
                  <p className="text-xs">No Data</p>
                )}
              </div>
            ) : (
              <table className="w-full border border-collapse  text-xs">
                {Array.isArray(value?.metadata) &&
                value?.metadata.length > 0 ? (
                  value?.metadata.map((item, indx) => (
                    <tr key={indx} className=" text-xs">
                      {/* <td className=" w-2/12 border">{value?.label||"-"}</td> */}
                      {Object.entries(item).map(([key, valueOf], idx) => (
                        <td key={idx} className="border py-1 px-2">
                          {valueOf == "text" ? (
                            <>
                              <NuTableFormInput
                                label={key}
                                type={"text"}
                                formik={formik}
                                placeholder={value?.Name}
                                name={`${key}${valueOf}${indx}`}
                                width={"w-full"}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex === false}
                                idx={indx + 1}
                              />
                            </>
                          ) : valueOf == "number" ? (
                            <>
                              <NuTableFormInput
                                label={key}
                                type={"text"}
                                formik={formik}
                                placeholder={value?.Name}
                                name={`${key}${valueOf}${indx}`}
                                width={"w-full"}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex === false}
                                idx={indx + 1}
                              />
                            </>
                          ) : valueOf == "legends" ? (
                            <>
                              <NuTableFormSelect
                                label={key}
                                type={"text"}
                                formik={formik}
                                placeholder={value?.Name}
                                name={`${key}${valueOf}${indx}`}
                                width={"w-full"}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex === false}
                                idx={indx + 1}
                                options={[
                                  {
                                    label: "c",
                                    value: "C",
                                  },
                                  {
                                    label: "t",
                                    value: "t",
                                  },
                                  {
                                    label: "o",
                                    value: "o",
                                  },
                                  {
                                    label: "N",
                                    value: "N",
                                  },
                                ]}
                              />
                            </>
                          ) : (
                            <>
                              <p>{key || ""}</p>
                            </>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <td>
                    <p>No Data</p>
                  </td>
                )}

                {/* <tr>
                <td className="w-2/12">
                  <p>{value?.field_label||""}</p>
                </td>

             </tr> */}
              </table>
            )}
          </>
        );
      case "yesnona":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"Yes" || ""}</p>
                      <InputCheckYes
                        type={"checkbox"}
                        formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex === false}
                        label={value?.field_label}
                      />
                    </div>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"No" || ""}</p>
                      <InputCheckNo
                        type={"checkbox"}
                        formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex === false}
                        label={value?.field_label}
                      />
                    </div>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"N/A" || ""}</p>
                      <InputCheckNone
                        type={"checkbox"}
                        formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex === false}
                        label={value?.field_label}
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "heading":
        return (
          <>
            <div className={` w-full py-2 text-xs  mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.field_label}</p>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "tableHeaders":
        return (
          <table className="w-full text-xs">
            <thead>
              {value?.field_label == "FIRE EXTINGUISHER DETAILS" ||
              value?.field_label == "FIRE / FOAM HOSE CABINET DETAILS" || value?.field_label == "FIRE / FOAM HOSE CABINET" ? (
                // <tr>
                //   <th className=" text-left p-2">Legends :</th>
                //   <th className=" text-left p-2">Good </th>
                //   <th className=" text-left p-2">Defective </th>
                //   <th className=" text-left p-2">Missing </th>
                //   <th className=" text-left p-2">N/A </th>
                // </tr>
                <p>:</p>
              ) : (
                <tr>
                  {Object.entries(value?.metadata).length > 10 ? (
                    <>
                      {Object.entries(value?.metadata).map(
                        ([key, valueOf], idx) => (
                          <th
                            className=" [writing-mode:vertical-lr] max-h-[150px] rotate-180 p-2 text-left min-w-[50px] max-w-[250px] py-2 text-xs border "
                            key={idx}
                          >
                            {key} test
                          </th>
                        )
                      )}
                    </>
                  ) : (
                    <>
                      {Object.entries(value?.metadata).map(
                        ([key, valueOf], idx) => (
                          <th
                            className=" min-w-[150px] max-w-[250px] py-2 text-xs border "
                            key={idx}
                          >
                            {key}
                          </th>
                        )
                      )}
                    </>
                  )}
                </tr>
              )}
            </thead>
          </table>
        );
      default:
        return <>No</>;
    }
  }
  const signOne = useRef(null);
  const signTwo = useRef(null);
  const signThree = useRef(null);
  const signFour = useRef(null);
  const signFive = useRef(null);

  const [signOneURL, setSignOneURL] = useState(null);
  const [signTwoURL, setSignTwoURL] = useState(null);
  const [signThreeURL, setSignThreeURL] = useState(null);
  const [signFourURL, setSignFourURL] = useState(null);
  const [signFiveURL, setSignFiveURL] = useState(null);

  const [isSignOneEnabled, setIsSignOneEnabled] = useState(false);
  const [isSignTwoEnabled, setIsSignTwoEnabled] = useState(false);
  const [isSignThreeEnabled, setIsSignThreeEnabled] = useState(false);
  const [isSignFourEnabled, setIsSignFourEnabled] = useState(false);
  const [isSignFiveEnabled, setIsSignFiveEnabled] = useState(false);

  const [showActionButtonsOne, setShowActionButtonsOne] = useState(false);
  const [showActionButtonsTwo, setShowActionButtonsTwo] = useState(false);
  const [showActionButtonsThree, setShowActionButtonsThree] = useState(false);
  const [showActionButtonsFour, setShowActionButtonsFour] = useState(false);
  const [showActionButtonsFive, setShowActionButtonsFive] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (signOne.current) {
        signOne.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (signOne.current) {
      isSignOneEnabled ? signOne.current.on() : signOne.current.off();
    }
  }, [isSignOneEnabled]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (signTwo.current) {
        signTwo.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (signTwo.current) {
      isSignTwoEnabled ? signTwo.current.on() : signTwo.current.off();
    }
  }, [isSignTwoEnabled]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (signThree.current) {
        signThree.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (signThree.current) {
      isSignThreeEnabled ? signThree.current.on() : signThree.current.off();
    }
  }, [isSignThreeEnabled]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (signFour.current) {
        signFour.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (signFour.current) {
      isSignFourEnabled ? signFour.current.on() : signFour.current.off();
    }
  }, [isSignFourEnabled]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (signFive.current) {
        signFive.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (signFive.current) {
      isSignFiveEnabled ? signFive.current.on() : signFive.current.off();
    }
  }, [isSignFiveEnabled]);

  const [image, setImage] = useState([]);
  const toast = useToast();


  
  const [imagePreviews, setImagePreviews] = useState([]); // Stores preview URLs
    function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };


  // function handleImageChange(e) {
  //   const maxFileSize = 200000000; // 200 MB
  //   const files = Array.from(e.target.files);
  //   let fileArr = [];

  //   files.forEach((item) => {
  //     if (item.size < maxFileSize) {
  //       fileArr.push(item);
  //     } else {
  //       toast.open({
  //         type: "warning",
  //         message: `File Size too big`,
  //         description: `${item.name} is removed and not uploaded`,
  //       });
  //     }
  //   });

  //   // Create preview URLs for new files
  //   const newPreviews = fileArr.map((file) => URL.createObjectURL(file));

  //   setSelectedFile((prev) => [...prev, ...fileArr]);
  //   setImagePreviews((prev) => [...prev, ...newPreviews]);
  //   FileAttachment([...selectedFile, ...fileArr]);

  //   // Reset input
  //   e.target.value = null;
  // }

  // const removeImages = (previewUrl) => {
  //   // Find the index of the file to remove
  //   const index = imagePreviews.findIndex((url) => url === previewUrl);

  //   if (index !== -1) {
  //     // Revoke the object URL to prevent memory leaks
  //     URL.revokeObjectURL(previewUrl);

  //     // Create new arrays without the removed file
  //     const newFiles = [...selectedFile];
  //     const newPreviews = [...imagePreviews];

  //     newFiles.splice(index, 1);
  //     newPreviews.splice(index, 1);

  //     setSelectedFile(newFiles);
  //     setImagePreviews(newPreviews);
  //     FileAttachment(newFiles);
  //   }
  // };

  // Clean up object URLs when component unmounts
  useEffect(() => {
    return () => {
      imagePreviews.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [imagePreviews]);

  // In your JSX

  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [listOfFile, setListOfFile] = useState([]);
  function UpdateAttachmentList(item) {
    let filterList = listOfFile.filter((itemList) => itemList.file !== item);
    let removeFile = listOfFile.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setListOfFile(filterList);
  }
  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }

  useEffect(() => {
    setListOfFile(allData?.attachments);
  }, [allData?.attachments]);

  return (
    <>
      <div className="w-full mx-auto h-auto  md:overflow-hidden   md:flex gap-2 text-[#111537]">
        <div className="w-full bg-white  overflow-y-scroll">
          <React.Fragment>
            <div>
              {/* {expandedIndex === index && ( */}
              <div className=" ">
                {formData &&
                  formData.map((tiltle, tiltleIndex) => {
                    return (
                      <div key={tiltleIndex} className="last:pb-4 ">
                        <label className="block text-sm 2xl:text-base font-medium text-white bg-baseColor-primary py-2 px-2">
                          {tiltle?.titleName || "-"}
                        </label>
                        {tiltle?.fields &&
                          tiltle?.fields.map((value, k) => {
                            return (
                              <div
                                key={k}
                                className="w-full border-b last:border-b-0 px-2.5 py-2 min-h-[90px] flex items-center"
                              >
                                {giveValue(value, formik)}
                              </div>
                            );
                          })}
                      </div>
                    );
                  })}

                {hasSign == true && (
                  <>
                    <div className="w-full grid md:grid-cols-2 gap-6 py-2 px-2 mb-10">
                      {/* Collector Signature */}
                      <>
                        {hasSignOne == true && (
                          <>
                            <div className="relative border w-full h-64 p-2 rounded-md bg-white">
                              <>
                                {allData?.signature1?.file?.length > 0 &&
                                isSignOneEnabled == false ? (
                                  <>
                                    <div className=" border border-gray-400 w-full h-52 rounded-md">
                                      <img
                                        src={allData?.signature1?.file}
                                        al="#"
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <SignatureCanvas
                                      penColor="black"
                                      canvasProps={{
                                        className:
                                          "border border-gray-400 w-full h-52 rounded-md",
                                      }}
                                      ref={signOne}
                                    />
                                  </>
                                )}
                              </>

                              <div className="flex justify-between items-center mt-1">
                                <span className="text-xs font-semibold text-gray-500">
                                  {SignOne || ""} :
                                </span>
                                <div className="flex gap-3">
                                  <button
                                    type="button"
                                    disabled={editModeIndex === false}
                                    onClick={() => {
                                      if (isSignOneEnabled) {
                                        signOne.current.clear();
                                        setIsSignOneEnabled(false);
                                        setShowActionButtonsOne(false);
                                        formik.setFieldValue(
                                          "collectorSignature",
                                          null
                                        ); // Clear formik value
                                      } else {
                                        setIsSignOneEnabled(true);
                                        setShowActionButtonsOne(true);
                                        setRemoveSignOne();
                                      }
                                    }}
                                    className={`text-xs px-3 py-1 rounded-md font-medium ${
                                      isSignOneEnabled
                                        ? "bg-red-500 text-white"
                                        : "bg-gray-200 text-textColor-main"
                                    }`}
                                  >
                                    {allData?.signature1?.file?.length > 0 &&
                                    isSignOneEnabled == false
                                      ? "Remove Signature"
                                      : isSignOneEnabled
                                      ? "Close"
                                      : "Add Signature"}
                                  </button>
                                  {showActionButtonsOne && (
                                    <>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          signOne.current.clear();
                                          setSignFunOne(null);
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            null
                                          ); // Clear formik value
                                        }}
                                        className="text-xs text-textColor-main px-3 py-1 rounded-md bg-gray-200"
                                      >
                                        Reset
                                      </button>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          if (signOne.current.isEmpty()) {
                                            alert(
                                              "Please provide a signature first"
                                            );
                                            return;
                                          }
                                          const dataURL =
                                            signOne.current.toDataURL(
                                              "image/png"
                                            );
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            dataURL
                                          ); // Save to formik
                                          const blob = dataURLtoBlob(dataURL);
                                          setSignOneURL(dataURL);
                                          setSignFunOne(blob);
                                          setIsSignOneEnabled(false);
                                          setShowActionButtonsOne(false);
                                        }}
                                        className="text-xs text-white px-3 py-1 rounded-md bg-blue-500"
                                      >
                                        Save
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>

                      <>
                        {hasSignTwo == true && (
                          <>
                            <div className="relative border w-full h-64 p-2 rounded-md bg-white">
                              <>
                                {allData?.signature2?.file?.length > 0 &&
                                isSignTwoEnabled == false ? (
                                  <>
                                    <div className=" border border-gray-400 w-full h-52 rounded-md">
                                      <img
                                        src={allData?.signature2?.file}
                                        al="#"
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <SignatureCanvas
                                      penColor="black"
                                      canvasProps={{
                                        className:
                                          "border border-gray-400 w-full h-52 rounded-md",
                                      }}
                                      ref={signTwo}
                                    />
                                  </>
                                )}
                              </>

                              <div className="flex justify-between items-center mt-1">
                                <span className="text-xs font-semibold text-gray-500">
                                  {SignTwo || ""} :
                                </span>
                                <div className="flex gap-3">
                                  <button
                                    type="button"
                                    disabled={editModeIndex === false}
                                    onClick={() => {
                                      if (isSignTwoEnabled) {
                                        signTwo?.current?.clear();
                                        setIsSignTwoEnabled(false);
                                        setShowActionButtonsTwo(false);
                                        formik.setFieldValue(
                                          "collectorSignature",
                                          null
                                        ); // Clear formik value
                                      } else {
                                        setIsSignTwoEnabled(true);
                                        setShowActionButtonsTwo(true);
                                        setRemoveSignTwo();
                                      }
                                    }}
                                    className={`text-xs px-3 py-1 rounded-md font-medium ${
                                      isSignTwoEnabled
                                        ? "bg-red-500 text-white"
                                        : "bg-gray-200 text-textColor-main"
                                    }`}
                                  >
                                    {allData?.signature2?.file?.length > 0 &&
                                    isSignTwoEnabled == false
                                      ? "Remove Signature"
                                      : isSignTwoEnabled
                                      ? "Close"
                                      : "Add Signature"}
                                  </button>
                                  {showActionButtonsTwo && (
                                    <>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          signTwo?.current?.clear();
                                          setSignFunTwo(null);
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            null
                                          ); // Clear formik value
                                        }}
                                        className="text-xs text-textColor-main px-3 py-1 rounded-md bg-gray-200"
                                      >
                                        Reset
                                      </button>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          if (signTwo?.current?.isEmpty()) {
                                            alert(
                                              "Please provide a signature first"
                                            );
                                            return;
                                          }
                                          const dataURL =
                                            signTwo?.current?.toDataURL(
                                              "image/png"
                                            );
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            dataURL
                                          ); // Save to formik
                                          const blob = dataURLtoBlob(dataURL);
                                          setSignTwoURL(dataURL);
                                          setSignFunTwo(blob);
                                          setIsSignTwoEnabled(false);
                                          setShowActionButtonsTwo(false);
                                        }}
                                        className="text-xs text-white px-3 py-1 rounded-md bg-blue-500"
                                      >
                                        Save
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>

                      <>
                        {hasSignThree == true && (
                          <>
                            <div className="relative border w-full h-64 p-2 rounded-md bg-white">
                              <>
                                {allData?.signature3?.file?.length > 0 &&
                                isSignThreeEnabled == false ? (
                                  <>
                                    <div className=" border border-gray-400 w-full h-52 rounded-md">
                                      <img
                                        src={allData?.signature3.file}
                                        al="#"
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <SignatureCanvas
                                      penColor="black"
                                      canvasProps={{
                                        className:
                                          "border border-gray-400 w-full h-52 rounded-md",
                                      }}
                                      ref={signThree}
                                    />
                                  </>
                                )}
                              </>

                              <div className="flex justify-between items-center mt-1">
                                <span className="text-xs font-semibold text-gray-500">
                                  {SignThree || ""} :
                                </span>
                                <div className="flex gap-3">
                                  <button
                                    type="button"
                                    disabled={editModeIndex === false}
                                    onClick={() => {
                                      if (isSignThreeEnabled) {
                                        signThree.current.clear();
                                        setIsSignThreeEnabled(false);
                                        setShowActionButtonsThree(false);
                                        formik.setFieldValue(
                                          "collectorSignature",
                                          null
                                        ); // Clear formik value
                                      } else {
                                        setIsSignThreeEnabled(true);
                                        setShowActionButtonsThree(true);
                                        setRemoveSignThree();
                                      }
                                    }}
                                    className={`text-xs px-3 py-1 rounded-md font-medium ${
                                      isSignThreeEnabled
                                        ? "bg-red-500 text-white"
                                        : "bg-gray-200 text-textColor-main"
                                    }`}
                                  >
                                    {allData?.signature3?.file?.length > 0 &&
                                    isSignThreeEnabled == false
                                      ? "Remove Signature"
                                      : isSignThreeEnabled
                                      ? "Close"
                                      : "Add Signature"}
                                  </button>
                                  {showActionButtonsThree && (
                                    <>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          signThree.current.clear();
                                          setSignFunThree(null);
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            null
                                          ); // Clear formik value
                                        }}
                                        className="text-xs text-textColor-main px-3 py-1 rounded-md bg-gray-200"
                                      >
                                        Reset
                                      </button>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          if (signThree.current.isEmpty()) {
                                            alert(
                                              "Please provide a signature first"
                                            );
                                            return;
                                          }
                                          const dataURL =
                                            signThree.current.toDataURL(
                                              "image/png"
                                            );
                                          const blob = dataURLtoBlob(dataURL);
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            dataURL
                                          ); // Save to formik
                                          setSignThreeURL(dataURL);
                                          setSignFunThree(blob);
                                          setIsSignThreeEnabled(false);
                                          setShowActionButtonsThree(false);
                                        }}
                                        className="text-xs text-white px-3 py-1 rounded-md bg-blue-500"
                                      >
                                        Save
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>

                      <>
                        {hasSignFour == true && (
                          <>
                            <div className="relative border w-full h-64 p-2 rounded-md bg-white">
                              <>
                                {allData?.signature4?.file?.length > 0 &&
                                isSignFourEnabled == false ? (
                                  <>
                                    <div className=" border border-gray-400 w-full h-52 rounded-md">
                                      <img
                                        src={allData?.signature4.file}
                                        al="#"
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <SignatureCanvas
                                      penColor="black"
                                      canvasProps={{
                                        className:
                                          "border border-gray-400 w-full h-52 rounded-md",
                                      }}
                                      ref={signFour}
                                    />
                                  </>
                                )}
                              </>

                              <div className="flex justify-between items-center mt-1">
                                <span className="text-xs font-semibold text-gray-500">
                                  {SignFour || ""} :
                                </span>
                                <div className="flex gap-3">
                                  <button
                                    type="button"
                                    disabled={editModeIndex === false}
                                    onClick={() => {
                                      if (isSignFourEnabled) {
                                        signFour.current.clear();
                                        setIsSignFourEnabled(false);
                                        setShowActionButtonsFour(false);
                                        formik.setFieldValue(
                                          "collectorSignature",
                                          null
                                        ); // Clear formik value
                                      } else {
                                        setIsSignFourEnabled(true);
                                        setShowActionButtonsFour(true);
                                        setRemoveSignFour();
                                      }
                                    }}
                                    className={`text-xs px-3 py-1 rounded-md font-medium ${
                                      isSignFourEnabled
                                        ? "bg-red-500 text-white"
                                        : "bg-gray-200 text-textColor-main"
                                    }`}
                                  >
                                    {allData?.signature4?.file?.length > 0 &&
                                    isSignFourEnabled == false
                                      ? "Remove Signature"
                                      : isSignFourEnabled
                                      ? "Close"
                                      : "Add Signature"}
                                  </button>
                                  {showActionButtonsFour && (
                                    <>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          signFour.current.clear();
                                          setSignFunFour(null);
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            null
                                          ); // Clear formik value
                                        }}
                                        className="text-xs text-textColor-main px-3 py-1 rounded-md bg-gray-200"
                                      >
                                        Reset
                                      </button>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          if (signFour.current.isEmpty()) {
                                            alert(
                                              "Please provide a signature first"
                                            );
                                            return;
                                          }
                                          const dataURL =
                                            signFour.current.toDataURL(
                                              "image/png"
                                            );
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            dataURL
                                          ); // Save to formik
                                          const blob = dataURLtoBlob(dataURL);
                                          setSignFourURL(dataURL);
                                          setSignFunFour(blob);
                                          setIsSignFourEnabled(false);
                                          setShowActionButtonsFour(false);
                                        }}
                                        className="text-xs text-white px-3 py-1 rounded-md bg-blue-500"
                                      >
                                        Save
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>

                      <>
                        {hasSignFive == true && (
                          <>
                            <div className="relative border w-full h-64 p-2 rounded-md bg-white">
                              <>
                                {allData?.signature5?.file?.length > 0 &&
                                isSignFiveEnabled == false ? (
                                  <>
                                    <div className=" border border-gray-400 w-full h-52 rounded-md">
                                      <img
                                        src={allData?.signature5.file}
                                        al="#"
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <SignatureCanvas
                                      penColor="black"
                                      canvasProps={{
                                        className:
                                          "border border-gray-400 w-full h-52 rounded-md",
                                      }}
                                      ref={signFive}
                                    />
                                  </>
                                )}
                              </>

                              <div className="flex justify-between items-center mt-1">
                                <span className="text-xs font-semibold text-gray-500">
                                  {SignFive || ""} :
                                </span>
                                <div className="flex gap-3">
                                  <button
                                    type="button"
                                    disabled={editModeIndex === false}
                                    onClick={() => {
                                      if (isSignFiveEnabled) {
                                        signFive.current.clear();
                                        setIsSignFiveEnabled(false);
                                        setShowActionButtonsFive(false);
                                        formik.setFieldValue(
                                          "collectorSignature",
                                          null
                                        ); // Clear formik value
                                      } else {
                                        setIsSignFiveEnabled(true);
                                        setShowActionButtonsFive(true);
                                        setRemoveSignFive();
                                      }
                                    }}
                                    className={`text-xs px-3 py-1 rounded-md font-medium ${
                                      isSignFiveEnabled
                                        ? "bg-red-500 text-white"
                                        : "bg-gray-200 text-textColor-main"
                                    }`}
                                  >
                                    {allData?.signature5?.file?.length > 0 &&
                                    isSignFiveEnabled == false
                                      ? "Remove Signature"
                                      : isSignFiveEnabled
                                      ? "Close"
                                      : "Add Signature"}
                                  </button>
                                  {showActionButtonsFive && (
                                    <>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          signFive.current.clear();
                                          setSignFunFive(null);
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            null
                                          ); // Clear formik value
                                        }}
                                        className="text-xs text-textColor-main px-3 py-1 rounded-md bg-gray-200"
                                      >
                                        Reset
                                      </button>
                                      <button
                                        type="button"
                                        disabled={editModeIndex === false}
                                        onClick={() => {
                                          if (signFive.current.isEmpty()) {
                                            alert(
                                              "Please provide a signature first"
                                            );
                                            return;
                                          }
                                          const dataURL =
                                            signFive.current.toDataURL(
                                              "image/png"
                                            );
                                          formik.setFieldValue(
                                            "collectorSignature",
                                            dataURL
                                          ); // Save to formik
                                          const blob = dataURLtoBlob(dataURL);
                                          setSignFiveURL(dataURL);
                                          setSignFunFive(blob);
                                          setIsSignFiveEnabled(false);
                                          setShowActionButtonsFive(false);
                                        }}
                                        className="text-xs text-white px-3 py-1 rounded-md bg-blue-500"
                                      >
                                        Save
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    </div>
                  </>
                )}
                <div className="w-full py-2 px-2 mb-10">
                  <Attachement
                    handleChange={handleImageChange}
                    disabled={editModeIndex === false}
                    // preview={imagePreviews} // Pass array of preview URLs
                                        preview={image || ""}

                    width="w-full"
                    label="Attach"
                    multiple={true}
                    removeImages={removeImages} // Pass the removal function
                  />
                </div>
                <div className=" w-full py-2 px-2 mb-10 flex flex-wrap gap-2">
                  {allData?.attachments &&
                    listOfFile?.map((imgs, idx) => {
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return <FilesView fileView={imgs} key={idx} />;
                    })}
                </div>
                {formData && (
                  <div className=" w-full flex justify-end items-center  gap-2 py-2 pb-5 px-2 mb-10 border-b border-gray-300">
                    <CancelButton
                      name="Save"
                      handleClick={() => SaveFormData()}
                    />
                    <SubmitButton />
                  </div>
                )}
              </div>
              {/* )} */}
            </div>
          </React.Fragment>
        </div>
      </div>
    </>
  );
}

export default NewCommonDynamicForm;
